import axios from 'axios'

import config from '../../config'

const updateFacility = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Facilities`
  return axios.put(url, data)
}

export default updateFacility
